import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import AddContext from "./textToSearch";
import TextToSearchResponse from "./textToSearchResponse";

const TextSeeker = () => {
  const { path } = useRouteMatch();
  return (
    <>
      <Switch>
        <Route exact path={`${path}`}>
          <Redirect to={`${path}/context`} />
        </Route>
        <Route path={`${path}/context`}>
          <AddContext />
        </Route>
        <Route path={`${path}/response`}>
          <TextToSearchResponse />
        </Route>
      </Switch>
    </>
  );
};

export default TextSeeker;
